'use strict';

// This the full list on the main org view
export const PEOPLE_LIST_NAME = 'people';
export const PEOPLE_LIST_PREFIX = `@@${PEOPLE_LIST_NAME}`;

// This is the selector modal list which is configured each time it is opened, based on context
export const PEOPLE_SELECTOR_LIST_NAME = 'peopleSelector';
export const PEOPLE_SELECTOR_LIST_PREFIX = `@@${PEOPLE_SELECTOR_LIST_NAME}`;

export const PEOPLE_SELECTOR_MODAL_NAME = 'peopleSelectorModal';
export const PEOPLE_SELECTOR_MODAL_PREFIX = `@@${PEOPLE_SELECTOR_MODAL_NAME}`;



// WEBPACK FOOTER //
// ./src/js/personnel/redux/state.js